var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlockTime = function SvgBlockTime(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.04 114H30.96A17 17 0 0 1 14 97.04V30.96A17 17 0 0 1 30.96 14h66.08A17 17 0 0 1 114 30.96v66.08A17 17 0 0 1 97.04 114M30.96 20.52a10.43 10.43 0 0 0-10.44 10.44v66.08c0 5.77 4.67 10.44 10.44 10.44h66.08c5.77 0 10.44-4.67 10.44-10.44V30.96c0-5.77-4.67-10.44-10.44-10.44z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 38,
    y: 42,
    rx: 2,
    ry: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 70,
    y: 42,
    rx: 2,
    ry: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 38,
    y: 66,
    rx: 2,
    ry: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 70,
    y: 66,
    rx: 2,
    ry: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlockTime);
export default ForwardRef;